import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  USER_DISABLE_REQUEST,
  userDisabled,
  userDisableError,
} from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import scDisableUser from "../../../../../backend/oncall/administration/users/disable";
import partnerDisableUser from "../../../../../backend/oncall/partners/users/disable";

const disable = function*(action) {
  try {
    const role = yield select(roleSelector);
    const disableUser = role === ADMIN ? scDisableUser : partnerDisableUser;
    yield call(disableUser, action.payload.username);
    yield put(userDisabled());
  } catch (error) {
    yield put(userDisableError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_DISABLE_REQUEST, disable);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/request-disable.js